/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    sessionId: number;
    status: number;
}

interface IOutput {
    comment_id: number;
    points_result: IPointsResult;
    study_info?: Record<string, any>;
}

export const makeDocReadSpeedStatus = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.MAKE_DOC_READ_SPEED_STATUS, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});

export const markWeikeStatus = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.MAKE_DOC_READ_SPEED_STATUS, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const makeDocReadSpeedStatusOld = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.MAKE_DOC_READ_SPEED_STATUS_OLD, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});

export const makeWeikeSpeedStatusOld = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.MAKE_DOC_READ_SPEED_STATUS_OLD, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
